import MasterTruckLumpsum from "./MasterTruckLumpsum.vue"
import MasterTruckLumpsumAdd from "./MasterTruckLumpsumAdd.vue"
import MasterTruckLumpsumEdit from "./MasterTruckLumpsumEdit.vue"

let routesMasterTruckLumpsum = [
    
    {
        path: '',
        meta: {
          title: "Chain System",
        },
        name: "MasterTruckLumpsum",
        component: MasterTruckLumpsum
    },
    {
        path: 'add',
        meta: {
          title: "Chain System",
        },
        name: "MasterTruckLumpsumAdd",
        component: MasterTruckLumpsumAdd
    },
     {
        path: 'edit/:id',
        meta: {
          title: "Chain System",
        },
        name: "MasterTruckLumpsumEdit",
        component: MasterTruckLumpsumEdit
    },
    // {
    //     path: 'detail/:id',
    //     meta: {
    //       title: "Chain System",
    //     },
    //     name: "MasterBatanganDetail",
    //     component: MasterBatanganDetail
    // },
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Chain System",
    //     },
    //     name: "MasterBatanganEdit",
    //     component: MasterBatanganEdit
    // },
    // {
    //     path: 'upload',
    //     meta: {
    //       title: "Chain System",
    //     },
    //     name: "MasterBatanganUpload",
    //     component: MasterBatanganUpload
    // },
   
  ]
  
  export default routesMasterTruckLumpsum 

